module.exports = __webpack_public_path__ + "static/media/IntegrateIllustration.913c0c31.svg";